angular.module('jv.moveAcrossWorkflow.controller', [])
    .controller('jvMoveAcrossWorkflowController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','$window','$timeout','jvHireUrlService','jvHireBroadcastSVC',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,$window,$timeout,jvHireUrlService,jvHireBroadcastSVC) {
            var isBulk, JV = $window.JV;
            var modalData;
            $scope.moveCandidateAcrossWorkflows = true;
            $scope.moveModalValidated = false;
            jvHireBroadcastSVC.subscribe('showMoveAcrossWorkflowsModal', function(event, bulk, data) {
                $scope.moveCandidateData = {};
                $scope.moveCandidateData.moveAndReject = true;
                isBulk = bulk;
                modalData = angular.extend(data);
                modalData.moveCandidateEnabled = false;
                modalData.candidateDetailsCheck = true;
               if(!$scope.appDetails && !$scope.applicationId && JV.Person && JV.Person.Global){
                    JV.Person.Global.grid.showLoadingState();
                }

                $scope.showModals('moveAcrossWorkflows');
                //Call validation api here to show/hide delete related checkbox
                 $scope.moveCandidateData.moveCandidateAcrossWorkflows = false;
                //Call validation api here to show/hide delete related checkbox
                  //$scope.moveAcrossDiffWorkflows = false;
                 if(modalData.moveAcrossDiffWorkflows){
                    $scope.moveCandidateData.moveCandidateAcrossWorkflows = true;
                    $scope.moveModalValidated = true;
                 }
                 else{
                
                   var args = {
                        destinationJobId: modalData.destinationJobId,
                        data: modalData.appIds[0],
                        CandidateListPage: modalData.CandidateListPage
                     };


                    jvCandidatesService.validateMoveModal(args, function(response){
                        if(response.data.moveAcrossDiffWorkflows === true){
                            $scope.moveCandidateData.moveCandidateAcrossWorkflows = true;
                        }
                        $scope.moveModalValidated = true;
                    });
                }
            });
            var i18n = angular.copy($scope.i18n);

            $scope.moveAcrossDiffWorkflows = {};
            // Modal Information
            $scope.modals = {
                moveAcrossWorkflows: {
                    show: false
                },
                duplicateCandidates : {
                    show: false
                }
            };
            //Used to show the move modal
            $scope.showModals = function(modal){
                TemplateLoader.load(modal).then(function(){
                        $scope.modals[modal].show = true;
                        if(JV.Person && JV.Person.Global){
                            JV.Person.Global.grid.removeLoadingState();
                        }
                });
            };

            //Used to hide all the modals on the page
            $scope.hideModals = function(){
                angular.forEach($scope.modals, function(val, key) {
                     $scope.modals[key].show = false;
                });
                if(JV.Person && JV.Person.Global){
                    JV.Person.resetValues();
                }
            };

            $scope.duplicateModal = {};
            var showDuplicateModal = function(data){
                $scope.duplicateModal.duplicateItems = data.notmoved;
                $scope.duplicateModal.successCount = data.count;
                $scope.duplicateModal.duplicateCount = $rootScope.size(data.notmoved);
                $scope.duplicateModal.modalTitle = $scope.duplicateModal.duplicateCount >1 ?  i18n['DUPLICATE_CANDIDATES_MOVED_MODAL_TITLE_MULTIPLE'] : i18n['DUPLICATE_CANDIDATES_MOVED_MODAL_TITLE_SINGLE'];
                $scope.duplicateModal.tableTitle = i18n['DUPLICATE_CANDIDATES_MOVED_TABLE_TITLE'];
                $scope.showModals('duplicateCandidates');
            };
            
            $scope.templates = TemplateLoader.register({
                moveAcrossWorkflows: '/jhire/modules/candidates/modals/moveAcrossWorkflows.html'
            });

            var removeLoadingState = function(){
                if($scope.CandidateListPage && JV.Person){
                    JV.Person.Global.grid.removeLoadingState();
                }else{
                   $scope.flags.loading = false;
                }
            };
            //Move Candidate
            $scope.moveAcrossWorkflows = function(bulkData,modData){
                modalData = modData || modalData;
                isBulk = bulkData || isBulk;
                if($scope.moveCandidateData.moveAndReject && modalData) {
                    $scope.flags.loading = true;
                    modalData.moveCandidateEnabled = false;
                    modalData.candidateDetailsCheck = true;
                    if(modalData.CandidateListPage) {
                        $rootScope.$broadcast('showRejectCandidateModal', isBulk, modalData);
                    }
                    else{
                        var rejectObject = {};
                        rejectObject.appId = $scope.applicationId;
                        rejectObject.candidateEId = $scope.appDetails.application.candidate.EId;
                        rejectObject.email = $scope.appDetails.application.candidate.email;
                        rejectObject.name = $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName;
                        rejectObject.allApplicationsList = $scope.allApplications.list;
                        rejectObject.rejectAll = false;
                        rejectObject.moveCandidateEnabled = false;
                        rejectObject.destinationJobId = modalData.destinationJobId;
                        rejectObject.isReject = true;
                        $rootScope.$broadcast('showRejectCandidateModal', false, rejectObject);
                    }
                    $scope.modals['moveAcrossWorkflows'].show = false;
                }
                else if(modalData)
                 {
                    var postData = {
                        destinationJobId: modalData.destinationJobId,
                        data: modalData.appIds
                    };
                    $scope.flags.loading = true;
                    jvCandidatesService.moveCandidateForSameWorkflow(postData,function(response){
                    $scope.flags.loading = false;
                    if(response && response.data && response.status === 200){
                        $scope.hideModals();
                        if(response.data && $rootScope.size(response.data.notmoved)>0){
                            $scope.moveModalConfig = true;
                            showDuplicateModal(response.data);
                            return false;
                        }
                        if(modalData.appIds.length === 1){
                            $rootScope.$emit('MOVE_SINGLE_CANDIDATE_SUCCESS', true);
                        }else{
                            $rootScope.$emit('MOVE_MULTIPLE_CANDIDATE_SUCCESS', modalData.appIds);
                        }

                        if($scope.CandidateDetailsPage || ($scope.appDetails && $scope.applicationId)){
                            //We need to reload the page with readMode=0
                            var CandidateDetailsUrl = jvHireUrlService.getApplicationDetailsUrl($scope.applicationId, true);
                            var toSearch = 'readMode=0';
                            if(location.href.split(toSearch)[1]){
                                //readMode=0 already exists in the url
                                location.reload();
                            }else{
                                location.replace(CandidateDetailsUrl);
                            }
                        }
                    }else{
                        //fail
                        removeLoadingState();
                    }
                });
                 }
            };
        }
]);